var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 3.5C1.39543 3.5 0.5 4.39543 0.5 5.5V8.5C0.5 9.65521 1.40955 10.3801 2.25077 10.5206C2.95957 10.639 3.5 11.2579 3.5 12C3.5 12.7421 2.95957 13.361 2.25077 13.4794C1.40954 13.6199 0.5 14.3448 0.5 15.5V18.5C0.5 19.6046 1.39543 20.5 2.5 20.5H21.5C22.6046 20.5 23.5 19.6046 23.5 18.5V15.5C23.5 14.3448 22.5905 13.6199 21.7492 13.4794C21.0404 13.361 20.5 12.7421 20.5 12C20.5 11.2579 21.0404 10.639 21.7492 10.5206C22.5905 10.3801 23.5 9.6552 23.5 8.5V5.5C23.5 4.39543 22.6046 3.5 21.5 3.5H2.5ZM2 5.5C2 5.22386 2.22386 5 2.5 5H14.25V19H2.5C2.22386 19 2 18.7761 2 18.5V15.5C2 15.2239 2.22554 15.0044 2.49791 14.9589C3.91779 14.7217 5 13.4872 5 12C5 10.5128 3.91779 9.2783 2.49791 9.04113C2.22554 8.99563 2 8.77614 2 8.5V5.5ZM15.75 19H21.5C21.7761 19 22 18.7761 22 18.5V15.5C22 15.2239 21.7745 15.0044 21.5021 14.9589C20.0822 14.7217 19 13.4872 19 12C19 10.5128 20.0822 9.2783 21.5021 9.04113C21.7745 8.99563 22 8.77614 22 8.5V5.5C22 5.22386 21.7761 5 21.5 5H15.75V19Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/Ticket.c11e2e2899bfcd424ffc03b5a185a33b.svg";
export { ForwardRef as ReactComponent };